import { render, staticRenderFns } from "./BaseTimerButton.vue?vue&type=template&id=f82dd020&scoped=true&"
import script from "./BaseTimerButton.vue?vue&type=script&lang=js&"
export * from "./BaseTimerButton.vue?vue&type=script&lang=js&"
import style0 from "./BaseTimerButton.vue?vue&type=style&index=0&id=f82dd020&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f82dd020",
  null
  
)

export default component.exports